// DemoFeatureRow.jsx
//
// FriendsDemo.jsx, SleepDemo.jsx et WeightDemo.jsx définissaient chacun,
// séparément, un `FullWidthSection` / `FeatureRow` / `FeatureRowText` /
// `FeatureRowVisual` avec exactement les mêmes valeurs (gap 2.5rem,
// padding 2.25rem 0, breakpoint 900px...). Copié-collé 3 fois à
// l'identique aujourd'hui, mais rien n'empêchait ces trois blocs de
// diverger au prochain edit. On centralise ici pour garantir que les 3
// démos gardent exactement le même rythme d'espacement.

import React from 'react';
import styled from 'styled-components';
import ScrollReveal from '../ScrollReveal';

export const FullWidthSection = styled.div`
  width: 100%;
  margin-bottom: 3rem;

  & > .feature-row-reveal:not(:last-child) {
    border-bottom: 1px solid #eef1f4;
  }
`;

/* ─── Bloc alterné texte / visuel ─── */
const FeatureRowFrame = styled.div`
  display: grid;
  grid-template-columns: ${({ $reverse }) => ($reverse ? '1fr minmax(240px, 340px)' : 'minmax(240px, 340px) 1fr')};
  align-items: center;
  gap: 2.5rem;
  padding: 2.25rem 0;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 1.5rem 0;
  }
`;

export const FeatureRow = ({ children, ...props }) => (
  <ScrollReveal className="feature-row-reveal">
    <FeatureRowFrame {...props}>{children}</FeatureRowFrame>
  </ScrollReveal>
);

export const FeatureRowText = styled.div`
  order: ${({ $reverse }) => ($reverse ? 2 : 1)};

  h3 {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    font-family: 'Poppins', sans-serif;
    font-size: 1.05rem;
    font-weight: 700;
    color: #1a2e40;
    margin: 0 0 0.6rem 0;
    svg { color: #2c5282; font-size: 0.95rem; }
  }
  p {
    font-family: 'Roboto', sans-serif;
    font-size: 0.9rem;
    color: #4a5568;
    line-height: 1.65;
    margin: 0 0 0.75rem 0;
    &:last-child { margin-bottom: 0; }
  }

  @media (max-width: 900px) {
    order: 1;
  }
`;

export const FeatureRowVisual = styled.div`
  order: ${({ $reverse }) => ($reverse ? 1 : 2)};
  min-width: 0;

  @media (max-width: 900px) {
    order: 2;
  }
`;
